var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSonioxLogoTitleWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 240 118.65",
    enableBackground: "new 0 0 240 118.65",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#0081D2",
    d: "M183.37,71.46V51.24c0-1.48-0.91-2.7-2.02-2.7s-2.02,1.21-2.02,2.7v20.22H183.37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0081D2",
    d: "M164.49,71.46V60.67c0-1.48-0.91-2.7-2.02-2.7s-2.02,1.21-2.02,2.7v10.79H164.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0081D2",
    d: "M126.74,71.46V26.97c0-1.48-0.91-2.7-2.02-2.7s-2.02,1.21-2.02,2.7v44.49H126.74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0081D2",
    d: "M136.18,71.46V41.8c0-1.48-0.91-2.7-2.02-2.7s-2.02,1.21-2.02,2.7v29.66H136.18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0081D2",
    d: "M155.06,71.46v-5.39c0-1.48-0.91-2.7-2.02-2.7s-2.02,1.21-2.02,2.7v5.39H155.06z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0081D2",
    d: "M145.62,71.46V51.24c0-1.48-0.91-2.7-2.02-2.7s-2.02,1.21-2.02,2.7v20.22H145.62z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0081D2",
    d: "M173.93,71.46V45.84c0-1.48-0.91-2.7-2.02-2.7s-2.02,1.21-2.02,2.7v25.62H173.93z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0081D2",
    d: "M192.81,71.46V55.28c0-1.48-0.91-2.7-2.02-2.7s-2.02,1.21-2.02,2.7v16.18H192.81z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0081D2",
    d: "M240,71.46v-9.44c0-1.48-0.91-2.7-2.02-2.7s-2.02,1.21-2.02,2.7v9.44H240z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0081D2",
    d: "M221.12,71.46V55.28c0-1.48-0.91-2.7-2.02-2.7s-2.02,1.21-2.02,2.7v16.18H221.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0081D2",
    d: "M230.56,71.46V51.24c0-1.48-0.91-2.7-2.02-2.7s-2.02,1.21-2.02,2.7v20.22H230.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0081D2",
    d: "M211.69,71.46v-39.1c0-1.48-0.91-2.7-2.02-2.7s-2.02,1.21-2.02,2.7v39.1H211.69z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0081D2",
    d: "M202.25,71.46v-6.74c0-1.48-0.91-2.7-2.02-2.7s-2.02,1.21-2.02,2.7v6.74H202.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0081D2",
    d: "M41.8,71.46V41.8c0-1.48-0.91-2.7-2.02-2.7c-1.11,0-2.02,1.21-2.02,2.7v29.66H41.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0081D2",
    d: "M117.3,71.46V41.8c0-1.48-0.91-2.7-2.02-2.7s-2.02,1.21-2.02,2.7v29.66H117.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0081D2",
    d: "M51.24,71.46V51.24c0-1.48-0.91-2.7-2.02-2.7c-1.11,0-2.02,1.21-2.02,2.7v20.22H51.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0081D2",
    d: "M22.92,71.46V41.8c0-1.48-0.91-2.7-2.02-2.7s-2.02,1.21-2.02,2.7v29.66H22.92z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0081D2",
    d: "M4.04,71.46v-8.09c0-1.48-0.91-2.7-2.02-2.7S0,61.89,0,63.37v8.09H4.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0081D2",
    d: "M13.48,71.46V51.24c0-1.48-0.91-2.7-2.02-2.7s-2.02,1.21-2.02,2.7v20.22H13.48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0081D2",
    d: "M60.67,71.46V36.4c0-1.48-0.91-2.7-2.02-2.7c-1.11,0-2.02,1.21-2.02,2.7v35.06H60.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0081D2",
    d: "M32.36,71.46V26.97c0-1.48-0.91-2.7-2.02-2.7s-2.02,1.21-2.02,2.7v44.49H32.36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0081D2",
    d: "M107.87,71.46V51.24c0-1.48-0.91-2.7-2.02-2.7s-2.02,1.21-2.02,2.7v20.22H107.87z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0081D2",
    d: "M98.43,71.46V36.4c0-1.48-0.91-2.7-2.02-2.7s-2.02,1.21-2.02,2.7v35.06H98.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0081D2",
    d: "M70.11,71.46V21.57c0-1.48-0.91-2.7-2.02-2.7c-1.11,0-2.02,1.21-2.02,2.7v49.89H70.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0081D2",
    d: "M79.55,71.46V2.7c0-1.48-0.91-2.7-2.02-2.7s-2.02,1.21-2.02,2.7v68.76H79.55z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0081D2",
    d: "M88.99,71.46V21.57c0-1.48-0.91-2.7-2.02-2.7s-2.02,1.21-2.02,2.7v49.89H88.99z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M0,112.86l5.06-8.22c4.42,2.93,9.27,4.43,13.27,4.43c2.35,0,3.42-0.71,3.42-2.07v-0.14 c0-1.5-2.14-2.14-6.21-3.29c-7.63-2-13.7-4.57-13.7-12.36v-0.14c0-8.22,6.56-12.79,15.48-12.79c5.64,0,11.49,1.64,15.91,4.5 l-4.64,8.58c-3.99-2.22-8.35-3.57-11.41-3.57c-2.07,0-3.14,0.79-3.14,1.86v0.14c0,1.5,2.21,2.22,6.28,3.43 c7.63,2.14,13.7,4.79,13.7,12.29v0.14c0,8.5-6.35,12.94-15.77,12.94C11.77,118.58,5.35,116.72,0,112.86z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M37.75,98.57v-0.14c0-11.01,8.99-20.22,21.4-20.22c12.34,0,21.26,9.08,21.26,20.08v0.14 c0,11.01-8.99,20.22-21.4,20.22C46.67,118.65,37.75,109.58,37.75,98.57z M67.22,98.57v-0.14c0-4.72-3.42-8.72-8.2-8.72 c-4.92,0-8.06,3.93-8.06,8.58v0.14c0,4.72,3.42,8.72,8.2,8.72C64.08,107.15,67.22,103.21,67.22,98.57z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M86.29,79.06h13.55v5.43c2.5-3.22,6.06-6.29,11.56-6.29c8.2,0,13.13,5.43,13.13,14.22v25.3h-13.55V96.78 c0-4.22-2.21-6.5-5.42-6.5c-3.28,0-5.71,2.29-5.71,6.5v20.94H86.29V79.06z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M132.13,79.06h13.55v38.66h-13.55V79.06z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M152.85,98.57v-0.14c0-11.01,8.99-20.22,21.4-20.22c12.34,0,21.26,9.08,21.26,20.08v0.14 c0,11.01-8.99,20.22-21.4,20.22C161.76,118.65,152.85,109.58,152.85,98.57z M182.31,98.57v-0.14c0-4.72-3.42-8.72-8.2-8.72 c-4.92,0-8.06,3.93-8.06,8.58v0.14c0,4.72,3.42,8.72,8.2,8.72C179.17,107.15,182.31,103.22,182.31,98.57z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M212.11,98.21l-12.77-19.15h14.62l5.71,9.5l5.71-9.5h14.34l-12.7,19.08L240,117.72h-14.55l-5.99-9.93 l-6.06,9.93h-14.27L212.11,98.21z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSonioxLogoTitleWhite);
export default __webpack_public_path__ + "static/media/sonioxLogoTitleWhite.d31ee5376b0f70761aa992c90e8121b3.svg";
export { ForwardRef as ReactComponent };